import React from 'react';
import ReactDOM from 'react-dom/client';
import { Root } from './root.js';
import { initAnalytics } from './analytics.js';
import './index.css';
// The faces of the labels drawn on the canvas, bundled so they work offline and need no CDN
import '@fontsource/big-shoulders-display/500';
import '@fontsource/big-shoulders-display/600';
import '@fontsource/ibm-plex-mono/500';

initAnalytics();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Root />);
